import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { ConsentProvider } from "@/context/ConsentContext";
import { CookieBanner } from "@/components/CookieBanner";
import { ScrollManager } from "@/components/ScrollManager";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Landing } from "@/pages/Landing";
import { LegalPage } from "@/pages/LegalPage";
import { ContactPage } from "@/pages/ContactPage";
import { NotFound } from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
      <LanguageProvider>
        <ConsentProvider>
        <ScrollManager />
        <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)] antialiased">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<LegalPage id="impressum" />} />
              <Route path="/datenschutz" element={<LegalPage id="datenschutz" />} />
              <Route path="/nutzungsbedingungen" element={<LegalPage id="nutzungsbedingungen" />} />
              <Route path="/agb" element={<LegalPage id="agb" />} />
              {/* Alte WordPress-URLs (u. a. in den App-Store-Einträgen hinterlegt) */}
              <Route path="/datenschutzerklaerung-huntersmapp-2-0" element={<Navigate to="/datenschutz" replace />} />
              <Route path="/datenschutzerklaerung-huntersmapp" element={<Navigate to="/datenschutz" replace />} />
              <Route path="/nutzungsbedingungen-huntersmapp-2-0" element={<Navigate to="/nutzungsbedingungen" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <CookieBanner />
        </ConsentProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
